export default __webpack_public_path__ + "static/media/ro1.d08cd6f3.jpg";